import { applyMiddleware, compose, createStore, combineReducers } from 'redux';
import thunk from 'redux-thunk';

import commonReducer from './reducers/commonReducer';
import locationReducer from './reducers/locationReducer';
import optionReducer from './reducers/optionReducer';
import shortListReducer from './reducers/shorlistReducer';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const allReducers = combineReducers({
  optRed: optionReducer,
  comRed: commonReducer,
  locRed: locationReducer,
  shortlistRed: shortListReducer,
});
const store = createStore(allReducers, composeEnhancers(applyMiddleware(thunk)));

export default store;
